import { produce } from 'immer';
import { SetState, create } from 'zustand';
import { GroupChatAction, GroupChatState, GroupChatStore } from '~/types';

const initialGroupChatState = (): GroupChatState => ({
  showSendButton: false,
  showGroupInfo: false,
  showChatShareOpen: false,
  value: '',
  enterGroupChatStep: 'CheckMember',
});

const groupChatActions = (
  set: SetState<GroupChatStore>,
  get: () => GroupChatStore,
): GroupChatAction => ({
  setShowSendButton: (showSendButton) => {
    set(
      produce((state: GroupChatStore) => {
        state.showSendButton = showSendButton;
      }),
    );
  },
  setShowGroupInfo: (value) => {
    set(
      produce((state: GroupChatStore) => {
        state.showGroupInfo = value;
      }),
    );
  },

  setValue: (newValue) =>
    set(
      produce((state: GroupChatStore) => {
        state.value = newValue;
      }),
    ),
  setShowChatShareOpen: (value) => {
    set(
      produce((state: GroupChatStore) => {
        state.showChatShareOpen = value;
      }),
    );
  },
  setEnterGroupChatStep: (enterGroupChatStep) => {
    set(
      produce((state: GroupChatStore) => {
        state.enterGroupChatStep = enterGroupChatStep;
      }),
    );
  },
  resetAll: () => set({ ...initialGroupChatState() }),
});

const useGroupChatStore = create<GroupChatStore>()((set, get) => ({
  ...initialGroupChatState(),
  ...groupChatActions(set, get),
}));

export default useGroupChatStore;
